var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[(_vm.alerta)?_c('div',[_c('alert-empty')],1):_vm._e(),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"lg12":""}},[_c('v-card',[[(_vm.loading)?_c('div',[_c('loading')],1):_vm._e(),_c('grid-contingencia',{attrs:{"rowsTable":_vm.rowsTable}})]],2)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }